import { createContext, useContext } from 'react';

import type { Pagination } from '__generated__/graphql-types-do-not-use';

import type { BffEnrolledProduct_ProductCardFragment as EnrolledProductType } from 'bundles/unified-home-common/queries/__generated__/BffEnrolledProductsQuery';

export type BffEnrolledProductsContextType = {
  enrolledProducts: EnrolledProductType[];
  completedCourseCardSlugs: Array<string>;
  pagination: Pagination;
  loading: boolean;
  refetchEnrolledProductsData: () => void;
  totalEnrolledProducts: Pagination['totalElements'];
  bffCompletedTotals?: number;
  bffInProgressTotals?: number;
  bffSavedTotals?: number;
};

const BffEnrolledProductsContext = createContext<BffEnrolledProductsContextType | undefined>(undefined);

/**
 * @description hook to access all the user's enrolled products info through the BFF
 */
export const useBffEnrolledProducts = () => {
  const context = useContext(BffEnrolledProductsContext);

  return {
    enrolledProducts: context?.enrolledProducts ?? [],
    completedCourseCardSlugs: context?.completedCourseCardSlugs ?? [],
    pagination: context?.pagination,
    loading: context?.loading,
    refetchEnrolledProductsData: context?.refetchEnrolledProductsData,
    totalEnrolledProducts: context?.totalEnrolledProducts,
    bffCompletedTotals: context?.bffCompletedTotals,
    bffInProgressTotals: context?.bffInProgressTotals,
    bffSavedTotals: context?.bffSavedTotals,
  };
};
export default BffEnrolledProductsContext;
